const LoadingMask = {
  install (Vue, options) {
    var loading
    var tabStopElements = []
    Vue.prototype.$loadingMask = {
      on: () => {
        document.querySelectorAll('input, button, textarea, li, a, select, [tabindex]').forEach((x) => {
          tabStopElements.push({ el: x, tabIndex: x.getAttribute('tabindex') })
          x.tabIndex = -1
        })
        loading = Vue.prototype.$loading({
          lock: true
        })
      },
      off: () => {
        if (loading) {
          tabStopElements.forEach((x) => {
            if (!x.tabIndex) {
              x.el.removeAttribute('tabindex')
            } else {
              x.el.tabIndex = x.tabIndex
            }
          })
          tabStopElements = []
          loading.close()
        }
      }
    }
  }
}
export default LoadingMask
